// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrodbreak[data-v-8ffd0a38]{word-break:break-all}", ""]);
// Exports
module.exports = exports;
